import { TypographyOptions, TypographyStyleOptions } from '@mui/material/styles/createTypography';
import { breakpoints } from '../breakpoints';

const MUI_BREAKPOINT_OFFSET = 0.05; // MUI applies a 0.05px offset to breakpoints to prevent overlap

const mobileBreakpoint = `@media (max-width:${breakpoints.values.md - MUI_BREAKPOINT_OFFSET}px)`;

const mainTypographies: TypographyOptions = {
  h1: {
    fontWeight: 400,
    fontSize: '3rem',
    lineHeight: '3.5rem',
    textTransform: 'capitalize',
    [mobileBreakpoint]: {
      fontSize: '1.75rem',
      fontWeight: 700,
      lineHeight: '2.25rem',
    },
  },
  h2: {
    fontWeight: 400,
    fontSize: '2.5rem',
    lineHeight: '3rem',
    textTransform: 'capitalize',
    [mobileBreakpoint]: {
      fontSize: '1.75rem',
      fontWeight: 700,
      lineHeight: '2.25rem',
    },
  },
  h3: {
    fontWeight: 700,
    fontSize: '2rem',
    lineHeight: '2.375rem',
    textTransform: 'capitalize',
    [mobileBreakpoint]: {
      fontSize: '1.75rem',
      lineHeight: '2.25rem',
    },
  },
  h4: {
    fontWeight: 700,
    fontSize: '1.75rem',
    lineHeight: '2.25rem',
    textTransform: 'capitalize',
    [mobileBreakpoint]: {
      fontSize: '1.5rem',
      lineHeight: '2rem',
    },
  },
  h5: {
    fontWeight: 700,
    fontSize: '1.5rem',
    lineHeight: '2rem',
    textTransform: 'capitalize',
    [mobileBreakpoint]: {
      fontSize: '1.375rem',
      lineHeight: '1.75rem',
    },
  },
  h6: {
    fontWeight: 500,
    fontSize: '1.375rem',
    textTransform: 'capitalize',
    lineHeight: '1.75rem',
    [mobileBreakpoint]: {
      fontSize: '1.25rem',
      lineHeight: '1.75rem',
    },
  },
  subtitle1: {
    fontWeight: 500,
    fontSize: '1.125rem',
    lineHeight: '1.625rem',
    [mobileBreakpoint]: {
      fontSize: '1rem',
      lineHeight: '1.5rem',
    },
  },
  subtitle2: {
    fontWeight: 500,
    fontSize: '1rem',
    letterSpacing: '0.0125rem',
    lineHeight: '1.5rem',
    [mobileBreakpoint]: {
      fontSize: '0.875rem',
      lineHeight: '1.375rem',
    },
  },
  body1: {
    fontWeight: 400,
    fontSize: '1rem',
    letterSpacing: '0.0125rem',
    lineHeight: '1.5rem',
  },
  body2: {
    fontWeight: 400,
    fontSize: '0.875rem',
    letterSpacing: '0.01875rem',
    lineHeight: '1.375rem',
  },
  button: {
    fontWeight: 600,
    fontSize: '0.875rem',
    textTransform: 'none',
    letterSpacing: '0.0125rem',
    lineHeight: '1.25rem',
  },
  overline: {
    fontSize: '0.75rem',
    fontWeight: 500,
    textTransform: 'none',
    letterSpacing: '0.015625rem',
    lineHeight: '1rem',
  },
  caption: {
    fontWeight: 500,
    fontSize: '0.6875rem',
    letterSpacing: '0.01875rem',
    lineHeight: '1rem',
  },
  h1Custom: {
    fontFamily: 'Michroma',
    fontSize: '2.5rem',
    fontWeight: 400,
  }
}; 
const createBoldTypography = (
  typographyRules?: Partial<TypographyStyleOptions>,
) => {
  const { [mobileBreakpoint]: mobileRules, ...rest } = typographyRules || {};

  return {
    ...rest,
    fontWeight: 700,
    fontFamily: 'Lato',
    ...(typeof mobileRules === 'object' && {
      [mobileBreakpoint]: {
        ...mobileRules,
        fontWeight: 700,
      },
    }),
  };
};

const boldTypographies = {
  h6Bold: createBoldTypography(mainTypographies.h6),
  subtitle1Bold: createBoldTypography(mainTypographies.subtitle1),
  subtitle2Bold: createBoldTypography(mainTypographies.subtitle2),
  body1Bold: createBoldTypography(mainTypographies.body1),
  body2Bold: createBoldTypography(mainTypographies.body2),
  captionBold: createBoldTypography(mainTypographies.caption),
  overlineBold: createBoldTypography(mainTypographies.overline),
};

const typographyOptions: TypographyOptions = {
  fontFamily: 'Lato',
  fontSize: 16,
  ...mainTypographies,
  ...boldTypographies,
};

export default typographyOptions;